export class LdsTag {
    data: any[] = [];
    domain: any;
}


// WEBPACK FOOTER //
// ./src/models/trend-live-models/LdsTag.ts